"use client";
import { Contest, Round } from "@/sources/kicker-amateur/types";
import { useState } from "react";
import { DropdownSelect } from "@/app/pwa/components/DropdownSelect";
import { SingleValue } from "react-select";
import { pwaTeamGamedayPath } from "@/utils/urlHelper";
import { useRouter } from "next/navigation";

interface RoundSelectProps {
  league: Contest;
  currentRound?: Round;
  teamId: number;
  rounds: Round[];
  widget?: boolean;
  className?: string;
}

export function RoundSelect({
  league,
  rounds,
  currentRound,
  teamId,
  widget,
  className = ""
}: RoundSelectProps) {
  const [show, setShow] = useState(false);

  const { push } = useRouter();

  return (
    <div className={`flex flex-col items-center space-y-2 ${className}`}>
      <h2 className=" font-compressed font-bold text-xl">
        {league.OfficalName}
      </h2>
      <div>
        <DropdownSelect
          className="z-20"
          options={rounds}
          isClearable={false}
          isSearchable={false}
          isMulti={false}
          controlShouldRenderValue={true}
          value={currentRound}
          isOptionSelected={(option) => option.Id === currentRound?.Id}
          formatOptionLabel={(data) => {
            return <>{data.Name}</>;
          }}
          onChange={(selectedOption: SingleValue<Round>) => {
            selectedOption &&
              push(
                pwaTeamGamedayPath(
                  teamId.toString(),
                  selectedOption.Id!.toString()
                )
              );
          }}
        />
      </div>
    </div>
  );
}
